<template>
<div>
 
    <div class="boxes">
      <div class="breadcrumbs-tab" v-for="navItem in item" :key="navItem.name">
        <div :class="navItem.status" @click="toNav?onBCchange(navItem):null"> 
          <div class="inner">{{navItem.id+1}}</div> 
           <!-- <div :class="navItem.status"> -->
            <span class="bctitle">{{navItem.name}}</span>
             <!-- </div> -->
           
        </div>
        
      </div>
    </div>
  
    </div>
</template>
<script>
export default {
  name: "cBreadCrumb",
  props: {
    item:{
      type: Array,
      default:null
    },
    toNav:{
      type: Boolean,
      default:false
    },
    },
  methods:{
    onBCchange(navItem){
      if(navItem.status!="bcItem")
        this.$emit('getStatus',navItem, undefined);
    }
  }
};
</script>
<style scoped>
body {
  margin: 50px;
}
.bctitle{
  padding: 5px
}
.boxes {
    margin-top:20px;
    margin-left:70px;
    margin-bottom:20px;
  display: flex;
  height: 20px;
  /* justify-content: space-between; */
  align-items: center;
  /* color:#fff; */
}
.boxes .bcItem {
  height: 10px;
  align-self: middle;
  position: relative;
  width: auto;
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  color:#c7c7c7;
  /* background: #C7C7C7; */
}
.boxes .bcItem.past {
  color:#c7c7c7; 
}
.boxes .bcItem.past .inner {
  color:#c7c7c7;
}
/* .boxes .box.past .inner {
  background: #1877a5;
}
.boxes .box:last-of-type {
  flex: 0;
} */
.boxes .bcItem .inner {
  color:white;
  white-space: nowrap;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  position: relative;
  background: #c7c7c7;
  align-self: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  border-radius: 50%;
  font-size: 12px;
  text-align: center;
}
.boxes .bcItem.current  {
  
  /* text-decoration-color: green; */ 
   color: green; 
 } 
.boxes .bcItem.current .inner {
  background: green;
}
</style>